/**
 * @generated SignedSource<<7043376c4e63c23635ac53596071eb32>>
 * @relayHash 925bf8c25a719baffd9d1d895ad50a13
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 925bf8c25a719baffd9d1d895ad50a13

import { ConcreteRequest } from 'relay-runtime';
export type deActivateComfortSignatureSubscription$variables = Record<PropertyKey, never>;
export type deActivateComfortSignatureSubscription$data = {
  readonly de_activateTelematikInfrastructureComfortSignature: {
    readonly errorMessage: string | null;
    readonly errorType: string | null;
    readonly isActivated: boolean;
  };
};
export type deActivateComfortSignatureSubscription = {
  response: deActivateComfortSignatureSubscription$data;
  variables: deActivateComfortSignatureSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ComfortSignatureActivationResult",
    "kind": "LinkedField",
    "name": "de_activateTelematikInfrastructureComfortSignature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActivated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "deActivateComfortSignatureSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "deActivateComfortSignatureSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "925bf8c25a719baffd9d1d895ad50a13",
    "metadata": {},
    "name": "deActivateComfortSignatureSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "1c76b8516d732ba05936399dd007817f";

export default node;
